import { Grid } from "@mui/material";
import React from "react";
import { useQuery } from "react-query";
import LocationApi from "../../services/Apis/Location.Api";
import MUIDataTable from "mui-datatables";
import moment from "moment";

const ComplainsList = () => {
  // Get Complians  ..

  const { data } = useQuery("GET_ALL_COMPLAINS", () =>
    LocationApi.getComplains()
  );

  //   Mui Table Columns ..
  const columns = [
    {
      name: "ID",
      label: "ID",
    },
    {
      name: "store",
      label: "Store",
      options: { filterOptions: { fullWidth: true } },
    },
    {
      name: "location",
      label: "Location",
      options: { filterOptions: { fullWidth: true } },
    },
    {
      name: "phoneNo",
      label: "Phone No",
      options: {
        filterOptions: { fullWidth: true },
        customBodyRender: (value) => value?.join(" , "),
      },
    },
    {
      name: "complain",
      label: "issues",
      options: {
        filterOptions: { fullWidth: true },
        customBodyRender: (value) => value?.join(" , "),
      },
    },
    {
      name: "comment",
      label: "Complaint",
      options: { filterOptions: { fullWidth: true } },
    },
    {
      name: "createdDate",
      label: "Created",
      options: {
        customBodyRender: (value) => {
          return moment(value).format("DD-MM-YYYY");
        },
      },
    },
    // Actions  ..
  ];

  //   Mui Table Options ..
  const options = {
    search: true,
    download: true,
    print: false,
    viewColumns: true,
    filter: true,
    filterType: "dropdown",
    // responsive,
    selectableRows: "none",
  };

  return (
    <>
      <Grid>
        <MUIDataTable
          data={data}
          title="Complaint List"
          columns={columns}
          options={options}
        />
      </Grid>
    </>
  );
};

export default ComplainsList;
